/* eslint-disable no-param-reassign */
/* eslint-disable react/jsx-props-no-spreading */
import React, { InputHTMLAttributes, useEffect, useRef } from 'react';
import { useField } from '@unform/core';

type InputProps = InputHTMLAttributes<HTMLInputElement>;

const InputCheckboxUnform: React.FC<InputProps> = ({ name, ...rest }) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const {
    fieldName, registerField,
  } = useField(String(name));

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef,
      getValue: (ref) => ref.current.checked,
      setValue: (ref, value: string) => {
        ref.current.checked = value;
      },
      clearValue: (ref) => {
        ref.current.value = '';
      },
    });
  }, [fieldName, registerField]);

  return (
    <input
      name={name}
      ref={inputRef}
      type="text"
      placeholder="Type your username"
      {...rest}
    />
  );
};

export default InputCheckboxUnform;
